const CAMPAIGN_VIEW_FILTER_TYPE = {
  ACTIVE_CAMPAIGNS: 'active',
}

export { CAMPAIGN_VIEW_FILTER_TYPE }
